import type { SVGProps } from 'react';
const SvgAccessAlarms = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#access_alarms_svg__a)">
      <path
        fill="currentColor"
        d="m22 5.7-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7ZM7.9 3.4 6.6 1.9 2 5.7l1.3 1.5 4.6-3.8ZM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8ZM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9Zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7Z"
      />
    </g>
    <defs>
      <clipPath id="access_alarms_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAccessAlarms;
